import React, { useMemo } from "react";
import { ImageWithFallback } from "./figma/ImageWithFallback";

const ALL_BG_IMAGES = [
  "https://images.unsplash.com/photo-1563841930606-67e2bce48b78",
  "https://images.unsplash.com/photo-1703763868053-3f2e10cbe73f",
  "https://images.unsplash.com/photo-1758272133406-159ba07499dc",
  "https://images.unsplash.com/photo-1625612446042-afd3fe024131",
  "https://images.unsplash.com/photo-1546528377-65924be33e1e",
  "https://images.unsplash.com/photo-1760126096208-2addef9d6486",
  "https://images.unsplash.com/photo-1625994761169-bf23651dfb2b",
  "https://images.unsplash.com/photo-1730463527127-7c6c1c1faf6d",
  "https://images.unsplash.com/photo-1661261400335-7dc71eb2b5a6",
  "https://images.unsplash.com/photo-1701374929875-37125c54cb29",
  "https://images.unsplash.com/photo-1758875913518-7869eb5e1e91",
  "https://images.unsplash.com/photo-1759088009958-14e99324925d",
  "https://images.unsplash.com/photo-1738913997758-fae7eeda38b5",
  "https://images.unsplash.com/photo-1543062591-e3c0fdb97350",
  "https://images.unsplash.com/photo-1514320291840-2e0a9bf2a9ae",
  "https://images.unsplash.com/photo-1501386761578-eac5c94b800a",
];

function shuffleArray(arr) {
  const shuffled = [...arr];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
}

export const BackgroundGrid = () => {
  const shuffledImages = useMemo(() => shuffleArray(ALL_BG_IMAGES), []);

  return (
    <div className="absolute inset-0 grid grid-cols-4 grid-rows-4 gap-2 opacity-[0.15]">
      {shuffledImages.map((src, i) => (
        <ImageWithFallback
          key={i}
          src={src}
          alt=""
          className="w-full h-full object-cover grayscale"
        />
      ))}
    </div>
  );
};
